import React, { PureComponent } from 'react';
import { graphql, StaticQuery } from 'gatsby';
// import { withTranslation } from 'react-i18next';

import { styled } from 'themes';

import Steps from './components/steps';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';

const StepByStep = (props) => {
  const [t] = useTranslation();

  function renderSteps() {
    const {
      data: {
        smallStepOne,
        largeStepOne,
        smallStepTwo,
        largeStepTwo,
        smallStepThree,
        largeStepThree,
        smallStepFour,
        largeStepFour,
        smallStepFive,
        largeStepFive,
      },
    } = props;

    const stepData = [
      {
        imageSmall: smallStepOne,
        imageLarge: largeStepOne,
        title: t('step-by-step.step-1-title'),
        text: t('step-by-step.step-1-text'),
      },
      {
        imageSmall: smallStepTwo,
        imageLarge: largeStepTwo,
        title: t('step-by-step.step-2-title'),
        text: t('step-by-step.step-2-text'),
      },
      {
        imageSmall: smallStepThree,
        imageLarge: largeStepThree,
        title: t('step-by-step.step-3-title'),
        text: t('step-by-step.step-3-text'),
      },
      {
        imageSmall: smallStepFour,
        imageLarge: largeStepFour,
        title: t('step-by-step.step-4-title'),
        text: t('step-by-step.step-4-text'),
      },
      {
        imageSmall: smallStepFive,
        imageLarge: largeStepFive,
        title: t('step-by-step.step-5-title'),
        text: t('step-by-step.step-5-text'),
      },
    ];

    return <Steps steps={stepData} />;
  }

  return (
    <Wrapper>
      <Title>{t('step-by-step.heading')}</Title>
      {renderSteps()}
    </Wrapper>
  );
};

const StepByStepContainer = props => (
  <StaticQuery
    query={graphql`
      query {
        smallStepOne: imageSharp(
          fluid: { originalName: { regex: "/1-reg.jpg/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        largeStepOne: imageSharp(
          fluid: { originalName: { regex: "/1-reg.png/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        smallStepTwo: imageSharp(
          fluid: { originalName: { regex: "/2-create.jpg/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        largeStepTwo: imageSharp(
          fluid: { originalName: { regex: "/2-create.png/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        smallStepThree: imageSharp(
          fluid: { originalName: { regex: "/3-assign.jpg/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        largeStepThree: imageSharp(
          fluid: { originalName: { regex: "/3-assign.png/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        smallStepFour: imageSharp(
          fluid: { originalName: { regex: "/4-booking.jpg/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        largeStepFour: imageSharp(
          fluid: { originalName: { regex: "/4-booking.png/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        smallStepFive: imageSharp(
          fluid: { originalName: { regex: "/5-pay.jpg/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        largeStepFive: imageSharp(
          fluid: { originalName: { regex: "/5-pay.png/" } }
        ) {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    `}
    render={data => <StepByStep data={data} {...props} />}
  />
);

export default StepByStepContainer;

const Wrapper = styled.div`
  grid-column: center-start / center-end;
  position: relative;
  margin-top: -10rem;
`;

const Title = styled.h2`
  position: relative;
  z-index: 10;
  margin-bottom: 3rem;

  @media ${device.mobileL} {
    margin-bottom: 1rem;
  }
`;
